import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { UnidataTable } from '~/components';
import { t } from '~/helpers';
import { handleExportGeneric } from '~/helpers/exportReports';
import {
  deleteData,
  findData,
  recordFiltering,
} from '~/store/modules/alarmeSistema/actions';

import Form from './form';

function AlarmeSistema() {
  const redux = useSelector((state) => state.alarmeSistema);

  const options = useMemo(
    () => [
      { value: t('s.geral.opcoes.nao'), label: 'N' },
      { value: t('s.geral.opcoes.sim'), label: 'S' },
    ],
    []
  );

  const header = useMemo(
    () => [
      {
        id: 'codigolabelsistema',
        label: t('s.configuracao.alarme.codigolabelsistema'),
        formatted: (value) => t(value),
        filter: {
          type: 'text',
        },
      },
      {
        id: 'geraalarmeconfigcliente',
        label: t('s.configuracao.alarme.geraalarmeconfigcliente'),
        formatted: (value) =>
          options.find((o) => o.label === value).value || '',
        filter: { type: 'select', options },
      },
      {
        id: 'enviaemailalarmeconfigcliente',
        label: t('s.configuracao.alarme.enviaemailalarmeconfigcliente'),
        formatted: (value) =>
          options.find((o) => o.label === value).value || '',
        filter: { type: 'select', options },
      },
    ],
    [options]
  );

  const fieldlist = [
    'codigolabelsistema',
    'geraalarmeconfigcliente',
    'enviaemailalarmeconfigcliente',
  ];

  const substituirHeader = {
    codigolabelsistema: t('s.configuracao.alarme.codigolabelsistema'),
    geraalarmeconfigcliente: t('s.configuracao.alarme.geraalarmeconfigcliente'),
    enviaemailalarmeconfigcliente: t(
      's.configuracao.alarme.enviaemailalarmeconfigcliente'
    ),
  };

  return (
    <UnidataTable
      fixed
      redux={redux}
      header={header}
      read={recordFiltering}
      find={findData}
      remove={deleteData}
      form={Form}
      keys="idalarmeconfig"
      detach="alarmeSistema"
      excel
      pdf
      onExport={(formato) =>
        handleExportGeneric({
          endpoint: 'alarmesconfigclientes',
          formato,
          fields: fieldlist,
          redux,
          headers: substituirHeader,
          title: 'Relatório de Alarmes do Sistema',
          ordination: redux.params.ordination,
          orderfield: redux.params.orderfield,
          substituirValores: {
            codigolabelsistema: {
              's.geral.alarmesistema.vazaonaoautorizada': t(
                's.geral.alarmesistema.vazaonaoautorizada'
              ),
              's.geral.alarmesistema.alteracaomodooperacional': t(
                's.geral.alarmesistema.alteracaomodooperacional'
              ),
              's.geral.alarmesistema.desempenhofrotaforamedia': t(
                's.geral.alarmesistema.desempenhofrotaforamedia'
              ),
              's.geral.alarmesistema.divergenciarecebimento': t(
                's.geral.alarmesistema.divergenciarecebimento'
              ),
              's.geral.alarmesistema.divergencialiberacaomovimentacao': t(
                's.geral.alarmesistema.divergencialiberacaomovimentacao'
              ),
              's.geral.alarmesistema.divergenciatransferenciacomboio': t(
                's.geral.alarmesistema.divergenciatransferenciacomboio'
              ),
              's.geral.alarmesistema.divergenciaturno': t(
                's.geral.alarmesistema.divergenciaturno'
              ),
              's.geral.alarmesistema.irregularidadedbic': t(
                's.geral.alarmesistema.irregularidadedbic'
              ),
              's.geral.alarmesistema.restricaotag': t(
                's.geral.alarmesistema.restricaotag'
              ),
              's.geral.alarmesistema.tanque': t('s.geral.alarmesistema.tanque'),
              's.geral.alarmesistema.tentativausotagrestrita': t(
                's.geral.alarmesistema.tentativausotagrestrita'
              ),
              's.geral.alarmesistema.pausasdbic': t(
                's.geral.alarmesistema.pausasdbic'
              ),
              's.geral.alarmesistema.estouroslaatendimento': t(
                's.geral.alarmesistema.estouroslaatendimento'
              ),
            },
            geraalarmeconfigcliente: {
              S: t('s.geral.opcoes.sim'),
              N: t('s.geral.opcoes.nao'),
            },
            enviaemailalarmeconfigcliente: {
              S: t('s.geral.opcoes.sim'),
              N: t('s.geral.opcoes.nao'),
            },
          },
        })
      }
    />
  );
}

export default AlarmeSistema;
